const productForms = [
  {
    name: '独立报关服务（快速跑通）',
    description: '低成本验证闭环，适合新手与低频需求',
    price: '9.9 / 99',
    unit: '起',
    features: [
      '快速验证合规流程',
      '适合低频出货场景',
      '即用即付，无长期承诺'
    ],
    cta: '先跑通一票',
    ctaType: 'tertiary',
    icon: 'ri-flashlight-line'
  },
  {
    name: '订阅版（长期合规管理）',
    description: '适合持续出货与规模化管理，核心是留痕与归档体系',
    price: '4,000',
    unit: '元/年起（9810）',
    subNote: '其他业务见详情',
    features: [
      '完整的合规管理体系',
      '数据归集与规则校验',
      '差异留痕与单证归档',
      '核销链路固化'
    ],
    cta: '查看产品及价格',
    ctaType: 'primary',
    icon: 'ri-shield-check-line',
    popular: true
  },
  {
    name: '服务包（能力增强）',
    description: '在订阅基础上增强退税/核算/值守支持（叠加项）',
    price: '7,500',
    unit: '元/年起',
    subNote: '退税服务包',
    features: [
      '退税支持服务',
      '核算支持服务',
      '值守保障服务',
      '需配合订阅版使用'
    ],
    cta: '咨询方案',
    ctaType: 'secondary',
    icon: 'ri-vip-crown-line'
  }
];

export default function Pricing() {
  const openConsultation = () => {
    const drawer = document.getElementById('consultation-drawer');
    if (drawer) drawer.classList.remove('translate-x-full');
  };

  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleCTA = (ctaType: string) => {
    if (ctaType === 'primary' || ctaType === 'tertiary') {
      scrollToPricing();
    } else {
      openConsultation();
    }
  };

  return (
    <section id="pricing" className="py-32 bg-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-[#14B8A6]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-[500px] h-[500px] bg-[#FF6B35]/5 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            产品与交付形态
          </h2>
          <p className="text-gray-600 text-lg">
            从验证到规模化，灵活选择适合你的产品形态
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {productForms.map((product, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl p-10 border-2 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl ${
                product.popular 
                  ? 'border-[#FF6B35] shadow-xl' 
                  : 'border-gray-200 hover:border-[#14B8A6]'
              }`}
            >
              {product.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-6 py-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white text-sm font-bold rounded-full shadow-lg whitespace-nowrap">
                  推荐
                </div>
              )}

              <div className="mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-[#14B8A6]/10 to-[#FF6B35]/10 rounded-2xl flex items-center justify-center mb-4">
                  <i className={`${product.icon} text-3xl text-[#FF6B35]`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {product.name}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {product.description}
                </p>
              </div>

              <div className="mb-8">
                <div className="flex items-baseline gap-2 mb-1">
                  <span className="text-4xl font-bold text-[#FF6B35]">
                    {product.price}
                  </span>
                  <span className="text-gray-500 text-sm">{product.unit}</span>
                </div>
                {product.subNote && (
                  <p className="text-xs text-gray-500 italic mt-1">
                    {product.subNote}
                  </p>
                )}
              </div>

              <div className="h-px bg-gray-200 my-6"></div>

              <ul className="space-y-3 mb-8">
                {product.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-start gap-3">
                    <i className="ri-check-line text-[#14B8A6] text-lg flex-shrink-0 mt-0.5"></i>
                    <span className="text-sm text-gray-700">
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => handleCTA(product.ctaType)}
                className={`w-full h-12 font-medium rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  product.ctaType === 'primary'
                    ? 'bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white hover:scale-105 shadow-lg'
                    : product.ctaType === 'secondary'
                    ? 'bg-white border-2 border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {product.cta}
              </button>
            </div>
          ))}
        </div>

        {/* Important Notice */}
        <div className="bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 border-[#FF6B35] rounded-lg p-6">
          <div className="flex items-start gap-4">
            <i className="ri-information-line text-2xl text-[#FF6B35] flex-shrink-0 mt-1"></i>
            <div>
              <p className="text-sm text-gray-700 font-medium mb-1">
                重要说明
              </p>
              <p className="text-sm text-gray-600">
                服务包为叠加项，不替代订阅费/免税费用。需在订阅版基础上使用，用于增强退税、核算或值守能力。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}